
var Model = require("../types/Model.js");
var moment = require("moment-timezone");

module.exports = Model({
	name: "timezonesetter",
	init: init,
	listeners: listeners,
	_has_checked: false,
});

function init(){
	this.push(moment.tz.guess());
}

function listeners(){
	return {
		"personal:updated": handle_preferences_update
	};
}

function handle_preferences_update(data){
	if(this._has_checked) return;
	// Don't bother checking if it isn't loaded
	if(!Object.keys(data).length)
		return;

	var timezone = data.timezone;
	if(timezone === this.data) return;
	this._has_checked = true;
	this.api.people.update({
		timezone: this.data
	}).catch(console.error.bind(console));
}